import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=6c2a0e66&lang=pug&"
import script from "./Message.ts?vue&type=script&lang=js&"
export * from "./Message.ts?vue&type=script&lang=js&"
import style0 from "./Message.sass?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports